// extracted by mini-css-extract-plugin
export default {"root":"ButtonWithMenu_root__XpteG","hover":"ButtonWithMenu_hover__ArE39","menu":"ButtonWithMenu_menu__cMW04","item":"ButtonWithMenu_item__sN7j2"};